function Select(props) {
	const { id, name, value, label, showLabel, className, style, onChange, children } = props;

	return (
		<div className={className ? `gs-select ${className}` : 'gs-select'} style={style}>
			{label && (
				<label id={label ? `${id}-label` : null} htmlFor={id} className={showLabel ? null : 'sr-only'}>
					{label}
				</label>
			)}
			<select
				id={id}
				name={name}
				aria-labelledby={label ? `${id}-label` : null}
				onChange={onChange}
				value={value}
			>
				{children}
			</select>
		</div>
	);
}

export default Select;
